import { render, staticRenderFns } from "./WebsiteZimbraPricing.vue?vue&type=template&id=be4b9848&scoped=true&"
import script from "./WebsiteZimbraPricing.vue?vue&type=script&lang=js&"
export * from "./WebsiteZimbraPricing.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteZimbraPricing.vue?vue&type=style&index=0&id=be4b9848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4b9848",
  null
  
)

export default component.exports